import React, { useState, useEffect } from 'react';
import { useAuthStore } from '../../lib/store-auth';
import { useManagerStore } from '../../lib/store-manager';
import { ManagerSimulations } from './simulations/ManagerSimulations';
import { ManagerPersonnel } from './personnel/ManagerPersonnel';
import './manager.scss';

interface ManagerLayoutProps {
    onLogout: () => void;
    onStartSimulation: (sim: any) => void;
}

export const ManagerLayout: React.FC<ManagerLayoutProps> = ({ onLogout, onStartSimulation }) => {
    const [activeTab, setActiveTab] = useState<'simulations' | 'personnel'>('simulations');
    const { user } = useAuthStore();
    const { fetchPersonnel, fetchSimulations } = useManagerStore();

    useEffect(() => {
        fetchPersonnel();
        fetchSimulations();
    }, [fetchPersonnel, fetchSimulations]);

    return (
        <div className="manager-layout">
            <aside className="manager-sidebar">
                <div className="sidebar-header">
                    <img src="/logo.svg" alt="Saletone Manager" />
                    <span>Müdür Paneli</span>
                </div>

                <div className="institution-badge">
                    <div className="inst-icon">
                        <span className="material-symbols-outlined">apartment</span>
                    </div>
                    <div className="inst-info">
                        <span className="inst-name">{user?.institution_details?.name || 'Kurum'}</span>
                        <span className="inst-role">Yönetici</span>
                    </div>
                </div>

                <nav className="sidebar-nav">
                    <button
                        className={`nav-item ${activeTab === 'simulations' ? 'active' : ''}`}
                        onClick={() => setActiveTab('simulations')}
                    >
                        <span className="material-symbols-outlined">smart_toy</span>
                        Simülasyonlar
                    </button>
                    <button
                        className={`nav-item ${activeTab === 'personnel' ? 'active' : ''}`}
                        onClick={() => setActiveTab('personnel')}
                    >
                        <span className="material-symbols-outlined">groups</span>
                        Personel
                    </button>
                </nav>

                <div className="sidebar-footer">
                    <div className="user-info">
                        <span className="user-name">{user?.full_name}</span>
                    </div>
                    <button className="logout-btn" onClick={onLogout}>
                        <span className="material-symbols-outlined">logout</span>
                    </button>
                </div>
            </aside>

            <main className="manager-content">
                {activeTab === 'simulations' ? (
                    <ManagerSimulations onStartSimulation={onStartSimulation} />
                ) : (
                    <ManagerPersonnel />
                )}
            </main>
        </div>
    );
};
